import React from 'react';

const LoadingSpinner = ({
  size = 'md',
  className = '',
  color = 'blue',
  thickness = '4'
}) => {
  const sizeClasses = {
    sm: 'h-4 w-4',
    md: 'h-8 w-8',
    lg: 'h-12 w-12',
    xl: 'h-16 w-16'
  };

  const getColorClass = (color) => {
    switch (color) {
      case 'blue': return 'border-t-blue-600 dark:border-t-blue-400';
      case 'gray': return 'border-t-gray-600 dark:border-t-gray-400';
      case 'green': return 'border-t-green-600 dark:border-t-green-400';
      case 'red': return 'border-t-red-600 dark:border-t-red-400';
      case 'purple': return 'border-t-purple-600 dark:border-t-purple-400';
      default: return 'border-t-blue-600 dark:border-t-blue-400';
    }
  };

  const getThicknessClass = (thickness) => {
    switch (thickness) {
      case '2': return 'border-2';
      case '4': return 'border-4';
      case '8': return 'border-8';
      default: return 'border-4';
    }
  };

  return (
    <div className={`animate-spin rounded-full ${getThicknessClass(thickness)} border-light-border-primary dark:border-dark-border-primary ${getColorClass(color)} ${sizeClasses[size]} ${className}`}></div>
  );
};

const Loader = ({
  variant = 'page', // 'page' | 'component' | 'inline' | 'overlay'
  size = 'md',
  text = '',
  className = '',
  spinnerClassName = '',
  textClassName = '',
  color = 'blue',
  thickness = '4',
  fullHeight = true,
}) => {
  const renderSpinner = () => (
    <LoadingSpinner
      size={size}
      color={color}
      thickness={thickness}
      className={spinnerClassName}
    />
  );

  const renderText = () => {
    if (!text) return null;
    return (
      <span className={`ml-2 text-light-text-secondary dark:text-dark-text-secondary ${textClassName}`}>
        {text}
      </span>
    );
  };

  // Inline loader - просто спиннер с текстом рядом
  if (variant === 'inline') {
    return (
      <div className={`flex items-center ${className}`}>
        {renderSpinner()}
        {renderText()}
      </div>
    );
  }

  // Overlay loader - полупрозрачный оверлей поверх контента
  if (variant === 'overlay') {
    return (
      <div className={`absolute inset-0 flex flex-col items-center justify-center bg-light-bg-primary dark:bg-dark-bg-secondary bg-opacity-75 z-10 ${className}`}>
        <div className="flex items-center justify-center">
          {renderSpinner()}
          {renderText()}
        </div>
      </div>
    );
  }

  // Component loader - для части компонента без фона
  if (variant === 'component') {
    const containerClass = fullHeight
      ? 'w-full flex-1 flex flex-col items-center justify-center'
      : 'w-full flex flex-col items-center justify-center py-6';

    return (
      <div className={`${containerClass} ${className}`}>
        <div className="flex items-center justify-center">
          {renderSpinner()}
          {renderText()}
        </div>
      </div>
    );
  }

  // Page loader - для всей страницы
  return (
    <div className={`flex flex-col items-center justify-center ${className}`}>
      <div className="flex flex-col items-center justify-center">
        {renderSpinner()}
        {renderText()}
      </div>
    </div>
  );
};

// Backward compatibility
export { Loader };
export default LoadingSpinner;
